const services = [
    { icon: "fa-globe", label: "Website Design" },
    { icon: "fa-brands fa-google", label: "Google Business Profile" },
    { icon: "fa-magnifying-glass-chart", label: "Local SEO" },
    { icon: "fa-bullhorn", label: "Google & Meta Ads" },
    { icon: "fa-phone-volume", label: "AI Voice Agents" },
    { icon: "fa-envelope-open-text", label: "Email Marketing" },
    { icon: "fa-comment-sms", label: "SMS Campaigns" },
    { icon: "fa-chart-line", label: "Monthly Reporting" },
];
export default function ServicePills() {
    const track = [...services, ...services, ...services];
    return (
        <section data-testid="service-pills" className="relative border-y border-[#1F3A2B] py-8 md:py-10 overflow-hidden bg-[#152A20]">
            <div className="max-w-[1240px] mx-auto px-8 mb-5">
                <div className="text-center mono text-[10.5px] text-[#7A9088]">— A FULL GROWTH STACK, UNDER ONE ROOF —</div>
            </div>
            <div className="flex whitespace-nowrap vu-marq-track">
                {track.map((s, i) => (
                    <div key={i} className="flex items-center shrink-0 gap-3 px-8 md:px-10 text-[#B8CFC0]">
                        <i className={`${s.icon.startsWith("fa-brands") ? s.icon : "fa-solid " + s.icon} text-[#DFFF3D] text-[15px]`} />
                        <span className="font-display text-[22px] md:text-[26px] tracking-tight leading-none">{s.label}</span>
                        <span className="w-1 h-1 rounded-full bg-[#2A4A38] ml-4" />
                    </div>
                ))}
            </div>
            <style>{`
                @keyframes vu-marq { from { transform: translate3d(0,0,0); } to { transform: translate3d(-33.33%,0,0); } }
                .vu-marq-track { animation: vu-marq 8s linear infinite; }
                @media (min-width: 768px) { .vu-marq-track { animation-duration: 14s; } }
            `}</style>
        </section>
    );
}
